import { Classes, Label } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { ItemSelector } from 'vet-bones/components';
import { SelectItem, createSelectItem } from 'vet-bones/utils/select';

import { NewProjectButton } from 'src/containers/Home/NewProjectButton';
import { ProjectSortOption } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

const orderByItems = Object.values(ProjectSortOption).map((option) =>
  createSelectItem(option, option)
);

type HeaderProps = {
  queryInputElement: JSX.Element;
};

export const Header: React.VFC<HeaderProps> = ({ queryInputElement }) => {
  const dispatch = useDispatch();
  const projectSortOption = useReduxSelector(
    (state) => state.ui.projectSortOption
  );
  const selectedSortOption = createSelectItem(
    projectSortOption,
    projectSortOption
  );

  const handleSelect = React.useCallback(
    (sortOption: SelectItem) => {
      dispatch(
        uiSlice.actions.changeProjectSortOption(
          sortOption.value as ProjectSortOption
        )
      );
    },
    [dispatch]
  );

  return (
    <div className={classNames('sd-home__header', Classes.ELEVATION_2)}>
      {queryInputElement}
      <div className="sd-home__actions">
        <Label className={Classes.INLINE}>
          {copy.components.home.orderBy}
          <ItemSelector
            buttonClassName={Classes.SMALL}
            buttonMinimal
            buttonText={selectedSortOption.text}
            filterable={false}
            items={orderByItems}
            onSelect={handleSelect}
            selected={selectedSortOption}
          />
        </Label>

        <NewProjectButton isImportAllowed />
      </div>
    </div>
  );
};
